import Vue from "vue";
import Vuex from "vuex";

import client from "./modules/client.js";
import user from "./modules/user.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    client,
    user,
  },
  state: {},
  mutations: {},
  actions: {},
});

export default store;